import { GrupoRespostaCampoDinamicoForm as GrupoRespostaCampoDinamicoFormOriginal } from '@elotech/components';

import { Informativo } from '../informativo';

type Props = React.ComponentProps<
  typeof GrupoRespostaCampoDinamicoFormOriginal
> & {
  canEdit: boolean;
};

export const GrupoRespostaCampoDinamicoForm: React.FC<Props> = ({
  canEdit,
  ...props
}) => {
  return (
    <fieldset disabled={!canEdit} style={{ border: 'none' }}>
      {!canEdit && (
        <Informativo type="WARNING" withIcon>
          Sem permissão para editar campos
        </Informativo>
      )}
      <GrupoRespostaCampoDinamicoFormOriginal {...props} />
    </fieldset>
  );
};
